<template>
  <div>
    <TheHeader />
    <transition mode="out-in">
      <div class="container-fluid">
        <div class="row hero">
          <div class="col-12 pt-5">
            <h1>Precisa de AJuda ?</h1>
            <p class="subtitle pt-2 text-white">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
          </div>
          <div class="col-12">
            <div class="form-row form_padrao">
              <div class="form-group flutuante col-md-12 position-relative">
                <input
                  type="text"
                  name="pesquisar"
                  id="pesquisar"
                  v-model="pesquisar"
                  @keyup="filterValue()"
                  required
                />
                <i class="material-icons search_icon">search</i>
                <label for="pesquisar" v-if="!pesquisar">Pesquisar...</label>
              </div>
            </div>
          </div>
        </div>

        <div
          class="row container d-flex justify-content-center flex-row align-items-center mx-auto pt-5"
          v-if="!loading"
        >
          <div
            class="col-md-6"
            v-for="(faq, index) in filterResult"
            :key="index"
          >
            <div
              class="card shadow-sm card_content mt-4 mt-md-0"
              v-if="filterResult.length"
            >
              <div class="card-body">
                <div
                  class="d-flex justify-content-between align-items-center mb-2"
                >
                  <i class="material-icons">help</i>
                </div>
                <div>
                  <h6 class="text-uppercase font-weight-bolder mb-3">
                    {{ faq.pergunta }}
                  </h6>
                  <small
                    class="text-muted small mt-3 pt-2"
                    v-html="faq.resposta"
                  >
                  </small>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12" v-if="!filterResult.length">
            <div class="row d-flex justify-content-center">
              <div class="col-md-6">
                <div class="card card_content mt-4 mt-md-0">
                  <div class="card-body">
                    <div
                      class="d-flex justify-content-center align-items-center mb-2"
                    >
                      <i
                        class="material-icons"
                        style="color: #05428e; font-size: 2rem"
                        >info</i
                      >
                    </div>
                    <div>
                      <h5 class="mb-3 mt-3 text-center">
                        Não encontramos nenhum resultado para sua busca.
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-else>
          <div class="col-12 d-flex justify-content-center align-items-center">
            <loading />
          </div>
        </div>
      </div>
    </transition>
    <TheFooter />
  </div>
</template>

<script>
import TheHeader from "@/components/TheHeader.vue";
import TheFooter from "@/components/TheFooter.vue";
import axios from "axios";
import { filterByValue } from "../../helpers";

export default {
  name: "Ajuda",
  components: {
    TheHeader,
    TheFooter,
  },
  data() {
    return {
      loading: false,
      filterResult: "",
      pesquisar: null,
      topics: "",
    };
  },
  methods: {
    filterValue() {
      this.filterResult = filterByValue(this.topics, this.pesquisar);
      console.log(this.filterResult);
    },

    getTopics() {
      this.loading = true;
      axios
        .get(process.env.VUE_APP_URL_PORTAL + "/wp-json/arta/faq", {
          headers: {
            Authorization: `Bearer ${process.env.VUE_APP_TOKEN_PORTAL}`,
          },
        })
        .then((response) => {
          this.loading = false;
          this.topics = response.data.faq;
          this.filterResult = response.data.faq;
        })
        .catch((error) => {
          this.loading = false;
          this.$toast.open({
            message: error.msg,
            type: "error",
          });
        });
    },
  },
  created() {
    this.getTopics();
  },
};
</script>

<style lang="scss" scoped>
.hero {
  min-height: 40vh;
  background: #05428e;
  justify-content: center;
  align-items: center;
  display: flex;
  text-align: center;
  background-image: url("../../assets/img/bg.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  h1 {
    font-size: 2rem;
    font-weight: 600;
    color: white;
  }
  .subtitle {
    max-width: 600px;
    display: flex;
    margin: 0 auto;
    line-height: 1.3rem;
  }
}

.flutuante {
  background: white;
  max-width: 700px;
  display: flex;
  margin: 0 auto;
}
.search_icon {
  position: absolute;
  top: 30%;
  right: 10px;
}
.form_padrao .form-group.flutuante label {
  left: 0px !important;
}
#pesquisar {
  background: white;
}
</style>
